<template>
  <div class="m-wap-main">
    <div class="m-wap-area">
      <div class="c-form c-wap-form">
        <div class="headBox">
          <div class="van_uploader">
            <van-uploader
              v-if="info.fileLimitType === 'IMG'"
              :after-read="afterChange"
              :before-read="beforeRead"
              :accept="info.accept"
              :disabled="info.disabled"
            >
              <div class="avatar-img">
                <span class="icon icontemp avatar" v-if="!info.value"></span>
                <img
                  :src="
                    info.value.newPath || info.fileUrl + info.value.mappingId
                  "
                  v-if="info.value"
                />
              </div>
            </van-uploader>
          </div>
          <!-- <div
            class="form-group"
            style="position: relative"
            :class="{ 'show-btns': info.value }"
            v-if="info.fileLimitType !== 'IMG'"
            >
            <input
              type="text"
              class="form-input"
              :value="info.value ? info.value.fileName : ''"
              readonly
              :disabled="info.disabled"
            />
            <button class="form-btn save">
              {{ info.isUpload ? "上传中" : "上传文件" }}
            </button>
            <input
              type="file"
              style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; opacity: 0;"
              :disabled="info.disabled || info.isUpload"
              :ref="info.fieldName"
              @change="fileChange($event)"
              :accept="info.accept"
            />
          </div> -->
          <div v-if="sizeError" :style="{color:'#c32c30'}">限2MB以下的jpg、jpeg、gif、png格式图片</div>
          <div
            v-if="info.fileLimitType === 'IMG' && !info.disabled"
            class="move_btns"
            :class="{
              'align-right': info.fileLimitType !== 'IMG' && info.value
            }"
          >
            <button
              class="form-btn cancel"
              v-if="info.value"
              @click="info.clearValue(); changeSizeErr();"
              :disabled="info.disabled"
              :style="{
                background: configStyle&&configStyle.formRowBgColor,
                color: configStyle&&configStyle.formColor
              }"
            >
              移除
            </button>
          </div>
        </div>
        <div
          class="m-area"
          v-for="o in list"
          :key="o.fieldName"
          :class="{ 'text-shuang': o.displayName.length > 5 }"
        >
          <SText v-if="o.displaySelectType === 'TEXT'" :info="o"></SText>
          <SDatetime
            v-if="o.displaySelectType === 'DATETIME'"
            :info="o"
          ></SDatetime>
          <!-- <SRadio v-if="o.displaySelectType === 'RADIO'" :info="o"></SRadio> -->
          <SCheckbox
            v-if="o.displaySelectType === 'CHECKBOX'"
            :info="o"
          ></SCheckbox>
          <SCheckboxSelect
            v-if="o.displaySelectType === 'CHECKBOXSELECT'"
            :info="o"
          ></SCheckboxSelect>
          <SSelect
            v-if="
              o.displaySelectType === 'SELECT' ||
                o.displaySelectType === 'RADIO'
            "
            :info="o"
          ></SSelect>
          <!-- <SFile v-if="o.displaySelectType === 'FILE'" :info="o"></SFile> -->
        </div>
        <div class="t-center">
          <button
            class="form-btn save"
            :style="{
              background: configStyle&&configStyle.themeColor,
              color: configStyle&&configStyle.saveBbtnColor
            }"
            :disabled="isDisabled"
            @click="save()"
          >
            保存
          </button>
        </div>
      </div>
    </div>
       <!-- <div class="m-loading-data" v-if="isLoading"></div> -->
  </div>
</template>

<script>
import { $subscriber } from "fire-wind-water/tools/subscriber";
import { cr } from "fire-wind-water/core";
import { createField, updateDirty } from "../../common/sbase";
import { memberFormId, schemaId, sess, tenantId } from "../../common/sbase";
import member from "../../services/member";
import {ck} from "fire-wind-water/cookie";
// import { interact } from "fire-wind-water/tools/interact";

export default {
  name: "Basis",
  data() {
    return {
      list: [],
      value: {},
      sizeError: false,
      isEdit: true,
      show: false,
      isLoading: true,
      isMobile: false,
      isDisabled: false,
      avatar: "",
      info: {},
      configStyle: null
    };
  },
  methods: {
    init() {
      $subscriber.subscribe("s-member-contact", data => {
        this.isLoading = false;
        window.$sk.loading.hide();
        this.value = data[1].fieldInfo;
        this.list = [];
        let avatar = {
          fieldName: "avatar",
          displayName: "头像",
          fieldType: "FILE",
          fileLimitType: "IMG",
          required: "0",
          displayType: "7"
        };
        cr.each(data[0].items, d => {
          if (d.fieldName === "avatar") {
            avatar = d;
            return;
          }
          if (d.fieldName === "password" || d.isLogin == 1) {
            return;
          }
          const item = createField(d);
          if (item) {
            this.list.push(item);
          }
        });
        avatar = createField(avatar);
        this.list.unshift(avatar);
        this.setValue();
        this.info = this.list[0];
      });
      $subscriber.subscribe("s-contact-init", data => {
        this.isLoading = false;
        window.$sk.loading.hide();
        this.value = data.fieldInfo;
        this.setValue();
      });
    },
    setValue() {
      cr.each(this.list, d => {
        if (this.value[d.fieldName]) {
          if (d.fieldType === "FILE") {
            d.initValue(
              this.value[d.fieldName] &&
                (this.value[d.fieldName].newPath ||
                  this.value[d.fieldName].mappingId)
                ? this.value[d.fieldName]
                : null
            );
          } else {
            d.initValue(this.value[d.fieldName] || null);
          }
        }
      });
    },
    save() {
      this.isDisabled = true;
      let isVer = updateDirty(this.list);
      if (isVer.isVerify) {
        let info = {
          tenantId: tenantId,
          schemaId: schemaId,
          memberFormId: memberFormId,
          sess: sess,
          globalUserId: decodeURIComponent(ck.cookie("globalUserId")).replaceAll('"', ''),
          formData: isVer.field
        };
        this.isLoading = true;
        member.updateIdentityInfo(info).subscribe(data => {
          this.isLoading = false;
          setTimeout(() => {
            this.isDisabled = false;
          }, 1);
          if (data.result != 0) {
            this.$message.error(data.desc);
          } else {
            this.$message.success("修改成功");
            $subscriber.emit("s-contact-get");
          }
        });
      }
    },
    changeSizeErr() {
      this.sizeError = false;
    },
    clearValue() {
      this.$refs[this.info.fieldName].value = "";
      this.info.clearValue();
    },
    fileChange(ev) {
      if (ev.target.files && ev.target.files.length > 0) {
        this.info.isFormatAndSize(ev.target.files[0]);
        this.info.upload({
          file: ev.target.files[0]
        });
      }
    },
    afterChange(e) {
      this.sizeError = false;
      if(e.file.size > 1024 * 1024 * 2) {
        this.sizeError = true;
      }
      this.info.isFormatAndSize(e.file);
      this.info.upload({
        file: e.file
      });
    },
    beforeRead() {
      return true;
    }
  },
  created() {
    this.init();
    $subscriber.subscribe("config-style", data=>{
      this.configStyle = data;
    });
//    this.configStyle = ck.cookie("configStyle");
  }
};
</script>

<style scoped></style>
